import gql from 'graphql-tag';

export const GET_DEALER_SUBMISSIONS_REPORT = gql`
  query LenderRetailActivityDealerSubmissionsReport($input: LenderRetailActivityReportInput!) {
    lenderRetailActivity {
      dealerSubmissionsReport(input: $input) {
        success
        error
        entity {
          creditSubmissionId
          createdDateTime
          customerName
          lenderName
          loanType
          model
          vin
          term
          status
          lenderDecision
          declineReason
          approvedAmount
          financedAmount
          timeOfDecision
          notes
        }
      }
    }
  }
`;
